import { IMFormErrorSection, IMFormModal, IMInputText } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SendInvitationModalStore } from 'store/modules/add-employees/ui-stores/sendInvitationModalStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { SEND_INVITATION_MODAL_ID } from '../constants';

interface Props {
  modalStore: SendInvitationModalStore;
}

export const SendInvitationModal: React.FC<Props> = observer(({ modalStore }) => {
  const { form, close } = modalStore;

  return modalStore.isVisible ? (
    <IMFormModal
      title="Send Invitation"
      show={modalStore.isVisible}
      onClose={close}
      formController={form}
      formId={SEND_INVITATION_MODAL_ID}
      formContent={
        <>
          <IMInputText label="Email Address" name="email" maxLength={100} $size="full" />
          <IMFormErrorSection />
        </>
      }
      submitButtonText="Send"
      closeButtonText="Cancel"
      resetOnClose={false}
      modalType={ModalType.EMAIL}
    />
  ) : null;
});
